module.exports = __webpack_public_path__ + "static/media/unit-circle-chart.079defe4.svg";